import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { HoverChildDirective } from './hover-child.directive'
import { HoverParentDirective } from './hover-parent.directive'

@NgModule({
    declarations: [HoverParentDirective, HoverChildDirective],
    exports: [HoverChildDirective, HoverParentDirective],
    imports: [CommonModule],
})
export class HoverModule {}
